export default __webpack_public_path__ + "static/media/prometheus.54ddd5ff.png";